/*
 * Copyright (c) 2025. Jellybean B.V.
 * Jellybean B.V. Apeldoorn heeft een licentie verleend aan
 * Spin in het Web B.V. Apeldoorn voor het gebruik van deze software-
 * onderdelen in projecten voor derden. U heeft géén toestemming
 * tot inzage of wijziging in de (bron)code van deze onderdelen.
 */

/*
* fullselectdirective.ts
* 2-12-2020 - Jelmer Jellema - Spin in het Web B.V.
*/

import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[sihwFullselect]',
  standalone: false
})
export class Fullselectdirective {
  constructor(private _el: ElementRef) {
  }

  @HostListener('focus', ['$event.target']) onFocus(target: HTMLInputElement | HTMLTextAreaElement) {
    target.select();
  }
}
